import _Tabs from "antd/es/tabs";
var _excluded = ["moreIcon"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import OneSymbolIcon from '../OneSymbolIcon';
import cs from 'classnames';
import './index.less';
function OneTabs(props) {
  var _props$moreIcon = props.moreIcon,
    moreIcon = _props$moreIcon === void 0 ? /*#__PURE__*/React.createElement(OneSymbolIcon, {
      icon: "icon-More-horizontal"
    }) : _props$moreIcon,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(_Tabs, _extends({
    moreIcon: moreIcon
  }, rest, {
    className: cs('one-tabs', props.className)
  }));
}
var TabPane = function TabPane(props) {
  return /*#__PURE__*/React.createElement(_Tabs.TabPane, _extends({}, props, {
    className: cs('one-tabs-pane', props.className)
  }));
};
OneTabs.TabPane = TabPane;
OneTabs.displayName = 'OneTabs';
export default OneTabs;